import classNames from 'classnames';

import {
  LoadingButton,
  type TpButtonLoadingProps,
} from '@mentalgrowth/ui-kit-web';

import styles from './UiKitLoadingButton.module.css';

export const UiKitLoadingButton = (props: TpButtonLoadingProps) => {
  const { className, ...otherProps } = props;
  return (
    <LoadingButton
      className={classNames(styles.button, className)}
      {...otherProps}
    />
  );
};
